import React, { useState, useEffect } from "react"
import { promotionsData } from "../../data/PromotionData"

export default function ModuleFaChaiGrandSpinAle({ closeModal }) {
  const promoData = promotionsData.find(
    (promo) => promo.title === "FC Grand Spin-Ale"
  )

  const [leaderboardData, setLeaderboardData] = useState([])
  const [loadingWeekly, setLoadingWeekly] = useState(true)
  const getBonusByRank = (rank) => {
    const r = parseInt(rank, 10)
    if (r === 1) return 600
    if (r === 2) return 350
    if (r === 3) return 250 
    if (r >= 4 && r <= 10) return 200
    if (r >= 11 && r <= 20) return 150
    if (r >= 21 && r <= 30) return 100
    return 0
  }

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        const url = `${process.env.REACT_APP_API_JSON_URL_PROMO}?cmd=getFCLeaderboard`
        const response = await fetch(url)
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`)

        const rawData = await response.json()

        const parsedData = Object.entries(rawData).map(([ranking, value]) => {
          const parts = value.split(",")
          const username = parts[0]?.trim()
          const score = parts[1]?.split("|")[1]?.trim() || "0"

          return {
            ranking, // "1", "2", ...
            username, // "ANI**0032**"
            score, // "12345"
          }
        })

        // Ensure 10 rows with dummy fallback
        const filledData = [...parsedData]

        for (let i = parsedData.length + 1; i <= 30; i++) {
          filledData.push({
            ranking: i.toString(),
            username: `Player${i}`, // dummy name
            score: "0", // dummy score
          })
        }

        setLeaderboardData(filledData.slice(0, 30))
      } catch (err) {
        console.error("Error fetching leaderboard data:", err)

        // If API fails, show full 10 dummy rows
        // const dummyData = Array.from({ length: 10 }, (_, i) => ({
        //   ranking: (i + 1).toString(),
        //   username: `Player${i + 1}`,
        //   score: "0",
        // }))
        // setLeaderboardData(dummyData)
      } finally {
        setLoadingWeekly(false)
      }
    }

    fetchLeaderboardData()
  }, [])

  return (
    <>
      <div className="promotion-module-pop-container">
        <div className="promotion-module-container">
          <button onClick={closeModal} className="promotion-close-btn">
            Close
          </button>
          <div className="promotion-module-main">
            <div className="promotion-leaderboard">
              <div className="promotion-module-banner">
                <img src={promoData.imgSrc} alt="Promotion Banner" />
                <div className="img-overlay"></div>
              </div>

              {/* … earlier code omitted for brevity … */}
              <div className="king-of-reel-title">
                Grand Spin-ale Leaderboard
              </div>
              <table
                className="promotion-module-table"
                style={{ marginTop: "5px" }}
              >
                <thead>
                  <tr>
                    <th>Ranking</th>
                    <th>Username</th>
                    <th>Total Spins</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingWeekly ? (
                    <tr>
                      <td
                        colSpan="3"
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        Loading...
                      </td>
                    </tr>
                  ) : leaderboardData.length > 0 ? (
                    leaderboardData.map((row, index) => {
                      let displayRank = row.ranking

                      // Lookup bonus amount by rank:
                      const bonusValue = getBonusByRank(row.ranking)
                      const bonusDisplay = bonusValue
                        ? bonusValue.toLocaleString()
                        : "–"

                      return (
                        <tr key={index}>
                          <td>{displayRank}</td>
                          <td>{row.username || "---"}</td>
                          <td>{bonusDisplay}</td>
                        </tr>
                      )
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="3"
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="promotion-module-cta">
              <span style={{ fontSize: "13px", paddingInline: "10px" }}>
                Leaderboard changes in real-time until the final result and
                awarding on October 31, 2025 - 2PM
              </span>
              <a href="/slots/?provider=fachai">
                <button className="promotion-module-leaderboard-btn">
                  Play Now
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
